"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _SettingField = require("./SettingField");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const EditableSettingsListFieldArray = _ref => {
  let {
    allowEdit = true,
    data,
    fields,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    onSave
  } = _ref;
  const handleSave = index => {
    const setting = fields.value[index];
    return onSave(setting);
  };
  return fields.map((setting, i) => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
      allowEdit: allowEdit,
      component: _SettingField.SettingField,
      "data-testid": "editableSettingsListFieldArray[".concat(i, "]"),
      intlKey: passedIntlKey,
      intlNS: passedIntlNS,
      labelOverrides: labelOverrides,
      name: setting,
      onSave: () => handleSave(i),
      settingData: {
        currentSetting: fields.value[i],
        ...data
      }
    }, setting);
  });
};
EditableSettingsListFieldArray.propTypes = {
  allowEdit: _propTypes.default.bool,
  fields: _propTypes.default.object,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  onSave: _propTypes.default.func,
  data: _propTypes.default.shape({
    refdatavalues: _propTypes.default.arrayOf(_propTypes.default.object)
  }),
  mutators: _propTypes.default.object,
  initialValues: _propTypes.default.object
};
var _default = exports.default = EditableSettingsListFieldArray;